import React from "react";
import { connect } from "react-redux";
import { layoutActions } from "../../store/layoutStore";
import {
  isOnPath,
  isObjectPathDefined,
  hasPermission,
} from "../../store/apiWrapper";
import "../layoutItems/rightPanel.scss";
import { bindActionCreators } from "redux";
import { userContextActions } from "../../store/userContextStore";
import PerfectScrollbar from "react-perfect-scrollbar";
import classnames from "classnames";
import ReactResizeDetector from "react-resize-detector";
import { isNullOrUndefined } from "../../store/storeFunctions";

import LastSearchedSubjectsWidget from "../search/widgets/lastSearchedSubjectsWidget";
import SearchFilter from "../common/searchFilter";
import SubjectClipboard from "../common/subjectClipboard";
import ReportSettings from "../report/reportSettings";
import ReportFilters from "../report/reportFilters";
// import ChartLegend from '../common/chartLegend';
import ChartLegend from "../common/chartLegend/chartLegend";
import ReportSectionsManager from "../common/reportSectionsManager";
import ReportSectionsPdfExport from "../common/reportSectionsPdfExport";
import ChartSettings from "../relationChart/chartSettings";
import MarketingListSectionsManager from "../marketingList/unicornSectionsManager";
import MarketingListExportSectionManager from "../marketingList/marketingListExportSectionManger";
import OverviewContent from "../marketingList/overviewContent";

import SvgBBiconsNaposledyProhlizene from "../../img/icons/BBicons_Naposledy_prohlizene";
import FilterIcon from "../../img/icons/BBicons_Filtr";
import SvgBBiconsPin from "../../img/icons/BBicons_Pin";
import SvgBBiconsSekce from "../../img/icons/BBicons_Sekce";
import SvgBBiconsFiltr from "../../img/icons/BBicons_Filtr";
import SvgBBIconsLegend from "../../img/icons/BBIconsLegend";
import SvgBBiconsHandlebar from "../../img/icons/BBicons_Handlebar";
import SvgBBiconsPdfSettings from "../../img/icons/BBicons_PDFsettings";
import SvgBBiconsSpravovatPortfolio from "../../img/icons/BBicons_Spravovat_portfolio";
import HelpManager from "../common/helpManager";
import {
  rightPanelItems,
  rightPanelStoreActions,
} from "../../store/rightPanelStore";

class RightPanel extends React.Component {
  _rightPanelItems = {
    "last-searched": {
      icon: SvgBBiconsNaposledyProhlizene,
      body: LastSearchedSubjectsWidget,
      hasIconMode: false,
      onlyIconMode: false,
    },
    "chart-settings": {
      icon: FilterIcon,
      body: ChartSettings,
      hasIconMode: false,
      onlyIconMode: false,
    },
    "subject-clipboard": {
      icon: SvgBBiconsPin,
      body: SubjectClipboard,
      hasIconMode: false,
      onlyIconMode: false,
    },
    "report-settings": {
      icon: SvgBBiconsSpravovatPortfolio,
      body: ReportSettings,
      hasIconMode: false,
      onlyIconMode: false,
    },
    "report-filters": {
      icon: SvgBBiconsFiltr,
      body: ReportFilters,
      hasIconMode: false,
      onlyIconMode: false,
    },
    "report-legend": {
      icon: SvgBBIconsLegend,
      body: ChartLegend,
      hasIconMode: false,
      onlyIconMode: false,
    },
    "sections-config": {
      visible_icon: SvgBBiconsSekce,
      minized_icon: null,
      body: ReportSectionsManager,
      hasIconMode: true,
      onlyIconMode: true,
    },
    "sections-pdf-export": {
      icon: SvgBBiconsPdfSettings,
      body: ReportSectionsPdfExport,
      hasIconMode: false,
      onlyIconMode: false,
    },
    "search-filter": {
      icon: FilterIcon,
      body: SearchFilter,
      hasIconMode: false,
      onlyIconMode: false,
    },
    "alerts-filter": {
      icon: FilterIcon,
      body: ReportFilters,
      hasIconMode: false,
      onlyIconMode: false,
    },
    "unicorn-sections": {
      icon: SvgBBiconsSpravovatPortfolio,
      body: MarketingListSectionsManager,
      hasIconMode: false,
      onlyIconMode: false,
    },
    "unicorn-export-sections": {
      icon: SvgBBiconsSpravovatPortfolio,
      body: MarketingListExportSectionManager,
      hasIconMode: false,
      onlyIconMode: false,
    },
    "unicorn-overview": {
      visible_icon: SvgBBiconsSpravovatPortfolio,
      minized_icon: null,
      body: OverviewContent,
      hasIconMode: false,
      onlyIconMode: false,
    },
    "help-redirect": { body: HelpManager },
  };

  static defaultProps = {
    initialWidth: 350,
    minimumWidth: 300,
    selectedId: "",
  };

  state = {
    initialized: false,
    resizing: false,
    startPosition: undefined,
    initialWidth: this.props.initialWidth,
    finalWidth: this.props.initialWidth,
    minimumWidth: this.props.minimumWidth,
    maximumWidth: 450,
    // selectedId: '',
    maxInnerWidth: 0,
  };

  componentDidMount() {
    document.body.classList.remove("rp-visible");
    if (!this.props.panel.expanded) {
      document.body.classList.add("rp-minimized");
    }
    window.addEventListener("resize", this.handleWindowResize);
    const that = this; // because of setInterval stupidity
    this.updaterInterval = window.setInterval(function() {
      that.updateScrollbar();
    }, 500);
    // handle alwaysOpen during bind process
    this.resolveAlwaysVisible();
  }

  updateScrollbar = () => {
    if (this._scrollRef !== null && this._scrollRef !== undefined) {
      this._scrollRef._ps.update(); // also needs to be called to update scrollbar after path change
      this._scrollRef.updateScroll();
    }
  };

  resolveAlwaysVisible = () => {
    if ((window._browser || {}).isMobile === true) {
      return; //do not open right panel when on mobile (or mobile resolution)
    }
    const availableItems = this.getVisibleItems();
    if (availableItems.length > 0) {
      const item = availableItems.filter((x) => x.alwaysOpen);
      if (item.length > 0) {
        this.toggleRightPanel(item[0].id);
      }
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.initialized) {
      let gridRef = document.querySelector(".grid-root");
      if (gridRef) {
        gridRef.addEventListener("mousemove", this.handleMouseMove);
        gridRef.addEventListener("mouseup", this.handleMouseUp);
        gridRef.addEventListener("mouseleave", this.handleMouseLeave);
      }
      this.setState({ initialized: true });
    }

    const availableItems = this.getVisibleItems();

    const items = availableItems.filter(
      (x) => x.id === this.props.panel.selectedId
    );
    if (items.length === 0 && this.props.panel.expanded) {
      this.toggleRightPanel(null, true);
    } else if (availableItems.length > 0 && !this.props.panel.expanded) {
      // disable auto-open when on mobile (or mobile resolution)
      if (!((window._browser || {}).isMobile === true)) {
        const item = availableItems.filter(
          (x) => x.open && this.getOpenValue(x.open)
        );
        if (!isNullOrUndefined(item) && item.length > 0) {
          this.toggleRightPanel(item[0].id);
        } else if (this.props.layout.location !== prevProps.layout.location) {
          this.resolveAlwaysVisible();
        }
      }
    } else if (
      availableItems.length > 0 &&
      this.props.panel.expanded &&
      !document.body.classList.contains("rp-visible")
    ) {
      this.props.onWidthChange(this.state.finalWidth, true);
      document.body.classList.remove("rp-minimized");
      document.body.classList.add("rp-visible");
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state != nextState ||
      this.props.panel.selectedId != nextProps.panel.selectedId ||
      this.props.panel.expanded != nextProps.panel.expanded ||
      this.props.layout.location !== nextProps.layout.location
    );
  }

  handleMouseMove = (e) => this.handleResize(e, "move");
  handleMouseUp = (e) => this.handleResize(e, "end");
  handleMouseLeave = (e) => this.handleResize(e, "end");

  componentWillUnmount() {
    if (this.state.initialized) {
      let gridRef = document.querySelector(".grid-root");
      if (gridRef) {
        gridRef.removeEventListener("mousemove", this.handleMouseMove);
        gridRef.removeEventListener("mouseup", this.handleMouseUp);
        gridRef.removeEventListener("mouseleave", this.handleMouseLeave);
      }
    }
    window.removeEventListener("resize", this.handleWindowResize);
    window.clearInterval(this.updaterInterval);
  }

  handleWindowResize = (e) => {
    if (this.props.panel.expanded) {
      const finalWidth = this.getNewWidth(null);
      this.setState(Object.assign({}, this.state, { finalWidth }));
      this.props.onWidthChange(finalWidth);
    }
  };

  render() {
    let items = this.getVisibleItems();
    if (items.length === 0) {
      return null;
    }
    let sorted = items.sort(function(a, b) {
      return a.order - b.order;
    });
    let withIcons = sorted.filter((x) => {
      let icn = this.props.panel.expanded
        ? x.visible_icon || x.icon
        : x.minized_icon || x.icon;
      return (icn !== null && icn !== undefined) || x.customHandler;
    });

    const active = withIcons.filter(
      (s) => s.id === this.props.panel.selectedId
    );

    return (
      <div
        className={classnames(
          "right-panel-wrapper",
          { tinted: this.props.tinted },
          "print-hidden"
        )}
        style={{ width: this.state.finalWidth }}
      >
        <div
          className="right-panel-shadow"
          onClick={() => this.toggleRightPanel(null)}
        ></div>
        <div
          className="right-panel-resizer"
          onMouseDown={(e) => this.handleResize(e, "start")}
        >
          <span>
            <SvgBBiconsHandlebar
              style={{
                transform: "rotate(90deg) translate(0px, 11px)",
                width: 26,
              }}
            />
          </span>
        </div>
        {this.renderControls(items, withIcons)}
        <PerfectScrollbar
          className="right-panel"
          ref={(el) => (this._scrollRef = el)}
          options={{ wheelPropagation: false }}
        >
          <div className="right-panel-section" style={{ padding: 0 }}>
            <ReactResizeDetector
              handleWidth
              refreshMode="debounce"
              refreshRate={500}
              onResize={this.onResize}
            />
          </div>
          {active.length === 1 &&
            active.map((a) => {
              const Content = a.body;
              return (
                <div key={a.order} className="right-panel-section">
                  <Content
                    maxWidth={this.state.maxInnerWidth}
                    closePanel={() => this.toggleRightPanel(null)}
                  />
                </div>
              );
            })}
        </PerfectScrollbar>
      </div>
    );
  }

  renderControls = (items, withIcons) => {
    let iconMode = items.filter((s) => {
      if (this.props.panel.expanded && s.onlyIconMode) {
        return false;
      }
      return s.hasIconMode === true;
    });
    return (
      <div className="right-panel-controls">
        {iconMode.length > 0 && (
          <div className="control-group-extras">
            {iconMode.map((x) => {
              let IconModeBody = x.body;
              return (
                <IconModeBody
                  key={x.id}
                  panelIconMode={true}
                  panelOpen={() => this.toggleRightPanel(x.id)}
                />
              );
            })}
          </div>
        )}
        {withIcons.length > 0 && (
          <div className="control-group-openers">
            {withIcons.map((x) => {
              if (x.customHandler) {
                let BodyHandler = x.body;
                return (
                  <BodyHandler
                    key={x.id}
                    iconHandler={true}
                    isActive={x.id === this.props.panel.selectedId}
                    itemKey={x.order}
                    panelOpen={() => this.toggleRightPanel(x.id)}
                  />
                );
              }
              let OpenerIcon = this.props.panel.expanded
                ? x.visible_icon || x.icon
                : x.minized_icon || x.icon;
              return (
                <div
                  key={x.order}
                  className={classnames("right-panel-icon", {
                    active: x.id === this.props.panel.selectedId,
                  })}
                  onClick={() => this.toggleRightPanel(x.id)}
                >
                  <div className="right-panel-icon-wrapper">
                    <div className="right-panel-icon-holder">
                      <OpenerIcon />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  getVisibleItems = () => {
    const panelItems = rightPanelItems.map((x) => {
      return { ...x, ...this._rightPanelItems[x.id] };
    });
    const visibleItems = panelItems.filter(
      (r) =>
        r.visible(this) &&
        r.body !== null &&
        r.body !== undefined &&
        ((r.icon !== null && r.icon !== undefined) ||
          (r.visible_icon !== null && r.visible_icon !== undefined) ||
          (r.minized_icon !== null && r.minized_icon !== undefined) ||
          r.customHandler)
    );
    return visibleItems;
  };

  onResize = (width, height) => {
    if (this.state.maxInnerWidth !== width) {
      this.setState({ maxInnerWidth: width });
    }
  };

  toggleRightPanel = (idToSelect, reload = false) => {
    let expanded = this.props.panel.expanded;
    let selectedId = this.props.panel.selectedId;
    if (expanded) {
      if (idToSelect !== null) {
        selectedId = idToSelect;
      } else {
        selectedId = "";
        expanded = false;
      }
    } else {
      if (idToSelect !== null) {
        selectedId = idToSelect;
        expanded = true;
      }
    }

    if (
      expanded !== this.props.panel.expanded ||
      selectedId !== this.props.panel.selectedId
    ) {
      if (!reload) {
        const panelItems = rightPanelItems.map((x) => {
          return { ...x, ...this._rightPanelItems[x.id] };
        });
        if (!isNullOrUndefined(this.props.panel.selectedId)) {
          const opened = panelItems.find(
            (x) => x.id === this.props.panel.selectedId && x.open
          );
          if (!isNullOrUndefined(opened)) {
            if (this.updateProfileValue(opened.open, "0")) {
              this.props.updateOpenRightPanel(opened.open, "0");
            }
          }
        }

        var item = panelItems.find(
          (x) =>
            x.id ===
              (isNullOrUndefined(idToSelect)
                ? this.props.panel.selectedId
                : idToSelect) && x.open
        );
        if (!isNullOrUndefined(item)) {
          if (this.updateProfileValue(item.open, expanded ? "1" : "0")) {
            this.props.updateOpenRightPanel(item.open, expanded ? "1" : "0");
          }
        }
      }
      this.props.toggleRightPanel(expanded, selectedId);
      this.setDocumentCss(expanded);
    }
  };

  setDocumentCss = (expanded) => {
    if (expanded !== this.props.panel.expanded) {
      if (expanded) {
        this.props.onWidthChange(this.state.finalWidth, true);
        document.body.classList.remove("rp-minimized");
        document.body.classList.add("rp-visible");
      } else {
        this.props.onWidthChange(0, true);
        document.body.classList.remove("rp-visible");
        document.body.classList.add("rp-minimized");
      }
    }
  };

  updateProfileValue = (id, extended) => {
    if (
      isObjectPathDefined(
        this.props,
        "user.authentication.profile.displaySettings"
      )
    ) {
      return (
        this.props.user.authentication.profile.displaySettings[id] !== extended
      );
    }
    return false;
  };

  getNewWidth = (event) => {
    let expected = this.state.finalWidth;
    if (event !== null) {
      expected =
        this.state.initialWidth + (this.state.startPosition.x - event.clientX);
    }
    return Math.max(
      this.state.minimumWidth,
      Math.min(expected, this.state.maximumWidth)
    );
  };

  handleResize = (event, type) => {
    if (!this.state.resizing) {
      if (type == "start") {
        this.setState(
          Object.assign({}, this.state, {
            resizing: true,
            initialWidth: this.state.finalWidth,
            startPosition: { x: event.clientX, y: event.clientY },
          })
        );
      }
    } else {
      if (type == "move") {
        const finalWidth = this.getNewWidth(event);
        this.setState(Object.assign({}, this.state, { finalWidth }));
        this.props.onWidthChange(finalWidth);
      } else if (type == "end") {
        this.setState(Object.assign({}, this.state, { resizing: false }));
        this.props.onWidthChange(null, true);
      }

      event.preventDefault();
      event.stopPropagation();
    }
  };

  getOpenValue = (subjectId) => {
    return (
      this.props.user.authentication.profile.displaySettings[subjectId] === "1"
    );
  };
}

export default connect(
  (state) => {
    return {
      layout: state.layout,
      user: state.userContext,
      panel: state.rightPanel,
    };
  },
  (dispatch) =>
    bindActionCreators(
      Object.assign(
        {},
        layoutActions,
        userContextActions,
        rightPanelStoreActions
      ),
      dispatch
    )
)(RightPanel);
